import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import {BASE_URL} from "../helpers/constants";
import * as actions from "../actions";
import sampleCombine from 'xstream/extra/sampleCombine';

export function requestCategoriesWithFilters(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_CATEGORIES_WITH_FILTERS)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/categories' + (
        action.payload && action.payload.filter?
          `?filter=${JSON.stringify(action.payload.filter)}`:''
      ),
      category: 'requestCategoriesWithFilters',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestCategoriesWithFilters')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getCategoriesWithFiltersSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestCategoriesWithFiltersFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestCategoriesWithFilters')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getCategoriesWithFiltersFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestCategories(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_CATEGORIES)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/categories' + (
        action.payload && action.payload.filter?
          `?filter=${JSON.stringify(action.payload.filter)}`:''
      ),
      category: 'requestCategories',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestCategories')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getCategoriesSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestCategoriesFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestCategories')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getCategoriesFailed(response));

  return {
    ACTION: httpResponse$
  }
}



// WEBPACK FOOTER //
// ./src/cycles/categories.js